import { Avatar, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { indigo } from "@material-ui/core/colors";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import PropTypes from "prop-types";

const TotalProfit = ({ statistic, ...props }) => (
  <Card {...props}>
    <CardContent>
      <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h6">
            LÃI ĐÃ THU TRONG THÁNG
          </Typography>
          <Typography color="textPrimary" variant="h3">
            {statistic.profitOfMonth?.toLocaleString("en-US") || 0} VNĐ
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: indigo[600],
              height: 56,
              width: 56
            }}
          >
            <AttachMoneyIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

TotalProfit.propTypes = {
  statistic: PropTypes.object
};

export default TotalProfit;
